import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col, Spinner, Table, Card } from 'react-bootstrap';
import { api } from "../../../services/api";
import Swal from "sweetalert2";
import { FaEdit, FaPlus, FaArrowLeft, FaCalendarCheck, FaPercent } from "react-icons/fa";

export default function ModalConcTaxa({ show, onHide }) {
    const [loading, setLoading] = useState(false);
    const [loadingEdicao, setLoadingEdicao] = useState(false);
    const [loadingAplicar, setLoadingAplicar] = useState(false);
    const [view, setView] = useState('lista');
    const [taxasCadastradas, setTaxasCadastradas] = useState([]);
    const [lookups, setLookups] = useState({ roteamentos: [], bandeiras: [], condicoes: [] });

    const [datasPeriodo, setDatasPeriodo] = useState({
        dtini: new Date().toISOString().split('T')[0],
        dtfim: new Date().toISOString().split('T')[0]
    });

    const converterDataParaAPI = (data) => {
        if (!data) return data;
        const [ano, mes, dia] = data.split('-');
        return `${dia}/${mes}/${ano}`;
    };

    const [form, setForm] = useState({
        roteamento: '',
        bandeira: '',
        condicao: '',
        taxa: 0,
        codicadastro: ''
    });

    useEffect(() => {
        if (show) {
            listarTaxas();
            carregarRoteamentos();
            setView('lista');
        }
    }, [show]);

    const carregarRoteamentos = () => {
        api.get('/financeiro/conciliacao/roteamentos')
            .then(res => setLookups(prev => ({ ...prev, roteamentos: res.data })))
            .catch(err => console.error("Erro ao carregar roteamentos", err));
    };

    const listarTaxas = async () => {
        setLoading(true);
        try {
            const res = await api.get('/financeiro/conciliacao/config-taxas');
            setTaxasCadastradas(res.data || []);
        } catch (err) {
            console.error("Erro ao listar taxas", err);
        } finally {
            setLoading(false);
        }
    };

    const handleAplicarNoPeriodo = async () => {
        const confirm = await Swal.fire({
            title: 'Confirmação',
            text: `Deseja aplicar as taxas atuais no período?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Cancelar'
        });

        if (!confirm.isConfirmed) return;

        setLoadingAplicar(true);
        try {
            const payload = {
                dtini: converterDataParaAPI(datasPeriodo.dtini),
                dtfim: converterDataParaAPI(datasPeriodo.dtfim)
            };
            await api.post('/financeiro/conciliacao/aplicar-taxas', payload);
            Swal.fire("Sucesso", "Taxas aplicadas!", "success");
        } catch (err) {
            Swal.fire("Erro", "Erro ao aplicar taxas", "error");
        } finally {
            setLoadingAplicar(false);
        }
    };

    const handleRoteamentoChange = async (val) => {
        setForm({ ...form, roteamento: val, bandeira: '', condicao: '' });
        if (!val) return;
        try {
            const res = await api.get(`/financeiro/conciliacao/bandeiras?roteamento=${val}`);
            setLookups(prev => ({ ...prev, bandeiras: res.data, condicoes: [] }));
        } catch (err) { console.error(err); }
    };

    const handleBandeiraChange = async (val) => {
        setForm({ ...form, bandeira: val, condicao: '' });
        if (!val) return;
        try {
            const res = await api.get(`/financeiro/conciliacao/condicoes?roteamento=${form.roteamento}&bandeira=${val}`);
            setLookups(prev => ({ ...prev, condicoes: res.data }));
        } catch (err) { console.error(err); }
    };

    const handleEditar = async (item) => {
        setLoadingEdicao(true);
        setView('formulario');
        try {
            const roteamento = item.ROTEAMENTO || item.roteamento;
            const bandeira = item.BANDEIRA || item.bandeira;
            const resB = await api.get(`/financeiro/conciliacao/bandeiras?roteamento=${roteamento}`);
            const resC = await api.get(`/financeiro/conciliacao/condicoes?roteamento=${roteamento}&bandeira=${bandeira}`);
            setLookups(prev => ({ ...prev, bandeiras: resB.data, condicoes: resC.data }));
            setForm({
                roteamento: roteamento,
                bandeira: bandeira,
                condicao: item.CONDICAO || item.condicao,
                taxa: item.TAXA || item.taxa,
                codicadastro: item.CODICADASTRO || item.codicadastro
            });
        } catch (err) {
            Swal.fire("Erro", "Falha ao carregar dados", "error");
        } finally {
            setLoadingEdicao(false);
        }
    };

    const handleSalvar = async () => {
        setLoading(true);
        try {
            await api.post('/financeiro/conciliacao/taxa', form);
            Swal.fire("Sucesso", "Configuração salva!", "success");
            listarTaxas();
            setView('lista');
        } catch (err) {
            Swal.fire("Erro", "Erro ao salvar", "error");
        } finally {
            setLoading(false);
        }
    };

    const renderDataList = (id, lista, campo) => (
        <datalist id={id}>
            {lista.map((item, index) => (
                <option key={index} value={typeof item === 'object' ? item[campo] : item} />
            ))}
        </datalist>
    );

    return (
        <Modal show={show} onHide={onHide} centered size="lg" backdrop="static" scrollable={true}>
            <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #8b0000 0%, #a91b0d 50%, #c0392b 100%)', color: '#ffffff' }} className="py-2 px-3 border-0">
                <Modal.Title className="fs-6 fw-bold d-flex align-items-center gap-2 text-white">
                    <FaPercent /> {view === 'lista' ? 'CONFIGURAÇÃO DE TAXAS' : 'EDITAR TAXA'}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="bg-light p-3" style={{ overflowX: 'hidden' }}>
                {view === 'lista' ? (
                    <>
                        <Card className="p-3 mb-3 border-warning shadow-sm rounded-3">
                            <h6 className="fw-bold small text-warning-emphasis mb-2 d-flex align-items-center gap-2">
                                <FaCalendarCheck /> APLICAR TAXAS AO PERÍODO
                            </h6>
                            <Row className="g-2 align-items-end">
                                <Col md={4}>
                                    <Form.Label className="small fw-bold text-secondary mb-1">Início</Form.Label>
                                    <Form.Control size="sm" type="date" value={datasPeriodo.dtini} onChange={e => setDatasPeriodo({ ...datasPeriodo, dtini: e.target.value })} />
                                </Col>
                                <Col md={4}>
                                    <Form.Label className="small fw-bold text-secondary mb-1">Fim</Form.Label>
                                    <Form.Control size="sm" type="date" value={datasPeriodo.dtfim} onChange={e => setDatasPeriodo({ ...datasPeriodo, dtfim: e.target.value })} />
                                </Col>
                                <Col md={4}>
                                    <Button variant="warning" size="sm" className="w-100 fw-bold shadow-sm" onClick={handleAplicarNoPeriodo} disabled={loadingAplicar}>
                                        {loadingAplicar ? <Spinner size="sm" /> : 'APLICAR NO BANCO'}
                                    </Button>
                                </Col>
                            </Row>
                        </Card>

                        <div className="d-flex justify-content-between mb-2 align-items-center">
                            <h6 className="fw-bold m-0 small text-secondary">Taxas Ativas</h6>
                            <Button variant="primary" size="sm" className="fw-bold d-flex align-items-center gap-1 shadow-sm" onClick={() => {
                                setForm({ roteamento: '', bandeira: '', condicao: '', taxa: 0, codicadastro: '' });
                                setView('formulario');
                            }}>
                                <FaPlus size={12} /> NOVA TAXA
                            </Button>
                        </div>

                        <div className="table-responsive bg-white shadow-sm border rounded-3" style={{ maxHeight: '420px', overflowY: 'auto' }}>
                            <Table striped bordered hover size="sm" className="mb-0 align-middle">
                                <thead className="table-secondary small text-center sticky-top">
                                    <tr>
                                        <th>Roteamento</th>
                                        <th>Bandeira</th>
                                        <th>Condição</th>
                                        <th>Taxa</th>
                                        <th width="60">Ações</th>
                                    </tr>
                                </thead>
                                <tbody className="small text-center">
                                    {loading ? (
                                        <tr><td colSpan="5" className="p-4"><Spinner animation="border" size="sm" style={{ color: '#8b0000' }} /></td></tr>
                                    ) : taxasCadastradas.map((t, i) => (
                                        <tr key={i}>
                                            <td className="fw-semibold text-secondary">{t.ROTEAMENTO || t.roteamento}</td>
                                            <td>{t.BANDEIRA || t.bandeira}</td>
                                            <td>{t.CONDICAO || t.condicao}</td>
                                            <td className="fw-bold text-danger">{Number(t.TAXA || t.taxa).toFixed(2)}%</td>
                                            <td>
                                                <Button variant="outline-danger" size="sm" className="py-0 px-2" onClick={() => handleEditar(t)}>
                                                    <FaEdit size={12} />
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                                    {!loading && taxasCadastradas.length === 0 && (
                                        <tr><td colSpan="5" className="p-4 text-muted">Nenhuma taxa cadastrada.</td></tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </>
                ) : (
                    <div className="bg-white p-3 rounded-3 shadow-sm border">
                        <Button variant="link" size="sm" onClick={() => setView('lista')} className="mb-3 p-0 text-decoration-none fw-bold text-danger d-inline-flex align-items-center gap-1">
                            <FaArrowLeft /> VOLTAR PARA LISTA
                        </Button>

                        {loadingEdicao ? (
                            <div className="text-center py-5"><Spinner animation="border" style={{ color: '#8b0000' }} /></div>
                        ) : (
                            <Form>
                                <Row className="g-3">
                                    <Col md={12}>
                                        <Form.Label className="small fw-bold text-secondary mb-1">Roteamento</Form.Label>
                                        <Form.Control
                                            size="sm"
                                            list="list-roteamentos"
                                            value={form.roteamento}
                                            onChange={e => handleRoteamentoChange(e.target.value)}
                                            placeholder="Selecione..."
                                        />
                                        {renderDataList("list-roteamentos", lookups.roteamentos, 'ROTEAMENTO')}
                                    </Col>

                                    <Col md={12}>
                                        <Form.Label className="small fw-bold text-secondary mb-1">Bandeira</Form.Label>
                                        <Form.Control
                                            size="sm"
                                            list="list-bandeiras"
                                            value={form.bandeira}
                                            onChange={e => handleBandeiraChange(e.target.value)}
                                            placeholder="Selecione..."
                                        />
                                        {renderDataList("list-bandeiras", lookups.bandeiras, 'BANDEIRA')}
                                    </Col>

                                    <Col md={12}>
                                        <Form.Label className="small fw-bold text-secondary mb-1">Condição</Form.Label>
                                        <Form.Control
                                            size="sm"
                                            list="list-condicoes"
                                            value={form.condicao}
                                            onChange={e => setForm({ ...form, condicao: e.target.value })}
                                            placeholder="Selecione..."
                                        />
                                        {renderDataList("list-condicoes", lookups.condicoes, 'CONDICAO')}
                                    </Col>

                                    <Col md={6}>
                                        <Form.Label className="small fw-bold text-secondary mb-1">Taxa (%)</Form.Label>
                                        <Form.Control size="sm" type="number" step="0.01" value={form.taxa} onChange={e => setForm({ ...form, taxa: e.target.value })} />
                                    </Col>
                                    <Col md={6}>
                                        <Form.Label className="small fw-bold text-secondary mb-1">Cód. Cadastro</Form.Label>
                                        <Form.Control size="sm" type="text" value={form.codicadastro} onChange={e => setForm({ ...form, codicadastro: e.target.value })} />
                                    </Col>
                                </Row>
                            </Form>
                        )}
                    </div>
                )}
            </Modal.Body>

            <Modal.Footer className="bg-white border-top-0 py-2 px-3">
                <Button variant="secondary" size="sm" className="fw-semibold" onClick={onHide}>FECHAR</Button>
                {view === 'formulario' && !loadingEdicao && (
                    <Button variant="primary" size="sm" className="fw-bold px-3" onClick={handleSalvar} disabled={loading}>
                        {loading ? 'GRAVAR...' : 'GRAVAR TAXA'}
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    );
}